export default __webpack_public_path__ + "static/media/FiraSans-Bold.d5e2e94a.otf";